<template>
  <v-text-field
    ref="decimalInput"
    :value="value"
    :min="min"
    :max="max"
    :step="step"
    :label="label"
    :suffix="unitSuffix ? '' : suffix"
    :readonly="readOnly"
    :disabled="disabled"
    :rules="rules"
    :solo="solo"
    :flat="flat"
    :hide-details="autoHideDetails === true ? 'auto' : hideDetails"
    :filled="filled"
    :dense="dense"
    :single-line="singleLine"
    :loading="loading"
    :hint="hint"
    :persistent-hint="persistentHint"
    type="number"
    :class="{ 'align-end': unitSuffix }"
    @focus.native="focusSelect ? $event.target.select() : () => {}"
    @click:clear="v => $emit('input', null)"
    @change="onChange"
    @input="onInput"
  >
    <template v-slot:append v-if="unitSuffix">
      <span class="caption">
        {{ suffix }}
      </span>
    </template>
    <template v-slot:prepend v-if="showActions">
      <v-btn tile icon x-small color="error" class="mb-1" @click="minusStep">
        <v-icon small>fa-minus-square</v-icon>
      </v-btn>
    </template>
    <template v-slot:append-outer v-if="showActions">
      <v-btn tile icon x-small color="success" class="mb-1" @click="plusStep">
        <v-icon small>fa-plus-square</v-icon>
      </v-btn>
    </template>
  </v-text-field>
</template>

<script>
import round10 from "round10";
export default {
  name: "DecimalInput",
  props: {
    value: {
      required: true,
      validator: function(v) {
        return !isNaN(Number(v)) || v === null;
      }
    },
    min: {
      default: null
    },
    max: {
      default: null
    },
    step: {
      default: "0.01"
    },
    label: {
      default: ""
    },
    suffix: {
      default: ""
    },
    hint: {
      default: ""
    },
    persistentHint: {
      type: Boolean,
      default: false
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    filled: {
      type: Boolean,
      default: false
    },
    decimal: {
      type: Number,
      default: 2
    },
    solo: {
      type: Boolean,
      default: false
    },
    flat: {
      type: Boolean,
      default: false
    },
    hideDetails: {
      type: Boolean,
      default: false
    },
    autoHideDetails: {
      type: Boolean,
      default: false
    },
    dense: {
      type: Boolean,
      default: false
    },
    singleLine: {
      type: Boolean,
      default: false
    },
    unitSuffix: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    showActions: {
      type: Boolean,
      default: false
    },
    focusSelect: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    rules() {
      let rules = [];
      if (this.required === true) {
        rules.push(v => !!v || `${this.label} est requis`);
        rules.push(v => v !== null || `${this.label} est requis`);
      }
      if (this.min !== null) {
        rules.push(v => v >= this.min || `Doit être supérieur à ${this.min}`);
      }
      if (this.max !== null) {
        rules.push(v => v <= this.min || `Doit être inférieur à ${this.max}`);
      }
      if (rules.length === 0) {
        rules.push(() => true);
      }
      return rules;
    }
  },
  methods: {
    onChange(v) {
      if (v !== undefined && v !== null) {
        const value = isNaN(v) ? parseFloat(v.replace(/,/g, ".")) : Number(v);
        this.$emit("input", Number(round10.round10(value, -this.decimal)));
        this.$emit("change", Number(round10.round10(value, -this.decimal)));
      } else {
        const value = null;
        this.$emit("input", Number(round10.round10(value, -this.decimal)));
        this.$emit("change", Number(round10.round10(value, -this.decimal)));
      }
    },
    onInput(v) {
      if (v !== undefined && v !== null) {
        const value = isNaN(v) ? parseFloat(v.replace(/,/g, ".")) : Number(v);
        this.$emit(
          "directinput",
          Number(round10.round10(value, -this.decimal))
        );
      } else {
        const value = null;
        this.$emit(
          "directinput",
          Number(round10.round10(value, -this.decimal))
        );
      }
    },
    minusStep() {
      this.$emit(
        "input",
        Number(round10.round10(this.value - Number(this.step), -this.decimal))
      );
      this.$emit(
        "change",
        Number(round10.round10(this.value - Number(this.step), -this.decimal))
      );
    },
    plusStep() {
      this.$emit(
        "input",
        Number(round10.round10(this.value + Number(this.step), -this.decimal))
      );
      this.$emit(
        "change",
        Number(round10.round10(this.value + Number(this.step), -this.decimal))
      );
    },
    focus() {
      this.$refs.decimalInput.focus();
    }
  }
};
</script>

<style lang="scss" scoped></style>
